// extracted by mini-css-extract-plugin
export default {"pageTitle":"PageTitle_pageTitle__bI1ZK","insidePage":"PageTitle_insidePage__GzKt+","titleMarginBottom":"PageTitle_titleMarginBottom__nP+d4","avatar":"PageTitle_avatar__N5DqP"};